export enum WhatsAppMsgTypeEnum{
    NORMAL = 0,
    WARNING = 1,
    ALERT = 2
}